import template from './leave_taken_report_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class LeaveTakenReportHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveTakenReportHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveTakenReportHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveTakenReportHelp',
	dialog_class: LeaveTakenReportHelpPage,
	template: template,
	template_filename: 'translation/dialogs/leave_taken_report_help',
	provider: 'ps'
};
